import {getTestProps} from '@benchling/js-test-utils';
import {Checkbox} from '@mantine/core';
import React from 'react';

import {
  isMSAConfigurable,
  type ScientificModelNode,
} from 'model-hub/scientific-models/ScientificModelMetadata';

interface UseMsaCheckboxProps {
  model: ScientificModelNode;
  msaEnabled: boolean;
  onMSAEnabledChange: (enabled: boolean) => void;
}

/**
 * "Use MSAs" toggle for models where MSA usage is configurable. Renders nothing for models that
 * require or don't support MSAs. Unlike the shared MSAOptions component, this intentionally omits
 * the "recently added" informational banner.
 */
export default function UseMsaCheckbox({
  model,
  msaEnabled,
  onMSAEnabledChange,
}: UseMsaCheckboxProps): JSX.Element | null {
  if (!isMSAConfigurable(model)) {
    return null;
  }

  return (
    <Checkbox
      checked={msaEnabled}
      label="Use MSAs"
      onChange={(event) => {
        onMSAEnabledChange(event.currentTarget.checked);
      }}
      {...getTestProps({component: 'UseMsaCheckbox', element: 'root'})}
    />
  );
}
